module.exports = __webpack_public_path__ + "img/magnit__text.8807300d.svg";